/* -------------------------------------------------------------------------------------------------
 Vendors
 ------------------------------------------------------------------------------------------------- */

import IMask from 'imask'; // imports only factory
import masks from './phone-masks';
import Modal from "./components/Modal";
import HoverObject from "./components/HoverObject";
import LightboxPopup from "./components/LightboxPopup";
import FormMaster from "./components/FormMaster";
import Chart from "./components/Chart";
import BriefForm from "./components/BriefForm";
import CallbackForm from "./components/CallbackForm";

window.addEventListener('error', event => {
    $.post('/reg-js-error', {
        data: event.error.stack
    });
});

$(function() {

    // delete after debug
    function screenSize() {
        var width = $(window).width(),
            height = $(window).height(),
            ratio = Math.round(width / height * 100) / 100;
        $('.js-debug').html(width + '<br>' + height + '<br>r=' + ratio);
    }

    screenSize();
    $(window).resize(screenSize);

    // pixel perfect debug
    //debug();

    //если iOS
    window.iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    window.isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    if (window.isMacLike === true) {
        $("body").addClass("mac-like");
    }

    // section name debug output
    $('.section, .slide').each(function() {
       var $section = $(this);
       if (!$section.attr('id')) {
           return;
       }
       $section.append('<div class="section__debug-info">' + $section.attr('id') + '</div>');
    });


    // phone mask
    document.querySelectorAll('.js-phone-mask').forEach(function(input) {
        IMask(input, {
            mask: masks,
            dispatch: (appended, dynamicMasked) => {
                console.log('dynamicMasked', dynamicMasked);
                console.log('appended', appended);
                const number = (dynamicMasked.value + appended).replace(/\D/g,'');
                return dynamicMasked.compiledMasks.find(m => number.indexOf(m.startsWith) === 0);
            }
        });
    });
/*
    // email mask
    document.querySelectorAll('.js-email-mask').forEach(function(input) {
        IMask(input, {
            mask: /^[a-zA-Z0-9_\.@-]+$/,
        });
    });
 */

    $('body')                   .each(function() { new Modal            ($(this)); });
    $('.js-hover-object')       .each(function() { new HoverObject      ($(this)); });
    $('.js-lightbox-popup')     .each(function() { new LightboxPopup    ($(this)); });
    $('.js-form-master')        .each(function() { new FormMaster       ($(this)); });

    $('.js-chart')              .each(function() { new Chart            ($(this)); });
    $('.js-brief-form')         .each(function() { new BriefForm        ($(this)); });
    $('.js-callback-form')      .each(function() { new CallbackForm     ($(this)); });

    /**
     * fix correct 1vh for ipad and browsers with header doesn't show off
     */
    function fixVhForIpad() {
        var objectHeight = document.querySelector('.treadmill__object') ?
            document.querySelector('.treadmill__object').clientHeight :
            0;
        if (Math.abs(Math.round(vhToPx(1) * 33.3) - objectHeight) > 1 && objectHeight > 0) {
            document.documentElement.style.setProperty('--vertical-size-unit', vhToPx(1) + 'px');
        }
    }

    var fixVhForIpadResizeTimer = null;
    $(window).on('resize', function() {

        clearInterval(fixVhForIpadResizeTimer);
        fixVhForIpadResizeTimer = setTimeout(fixVhForIpad, 300);
    });

    fixVhForIpad();

    // скрывать курсор после скролла
    $('.js-mobile-scroll').each(function() {

        var $scroll = $(this),
            $container = $scroll.closest('.js-scroll-container'),
            $drag = $container.find('.js-drag'),
            timer = null,
            dragIsVisible = $drag.is(':visible');

        $scroll.on('scroll', function() {
            if (!dragIsVisible) {
                return;
            }

            clearTimeout(timer);
            timer = setTimeout(hideDrag, 500);
        });

        function hideDrag() {
            $drag.css({'opacity': 0});
            dragIsVisible = false;
        }
    });

    $(".js-video").each(function(){
        var thisVideoBlock = $(this);

        var $videoUrl = thisVideoBlock.attr('data-video'),
            $videoType = parseVideo($videoUrl).type,
            $videoId = parseVideo($videoUrl).id;

        if ($videoType === 'vimeo') {
            thisVideoBlock.html('<iframe class="vimeo" src="https://player.vimeo.com/video/'+$videoId+'?autoplay=1&loop=1&muted=1&autopause=0&background=1&title=0&byline=0&portrait=0" allowfullscreen="allowfullscreen"></iframe>');
        }
    });
});

//vimeo video in case page
var parseVideo = function (url) {

    url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis|be-nocookie\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

    var type = null;

    if (RegExp.$3.indexOf('youtu') > -1) {
        type = 'youtube';
    } else if (RegExp.$3.indexOf('vimeo') > -1) {
        type = 'vimeo';
    }

    return {
        type: type,
        id: RegExp.$6
    };
};

// TODO delete
function getSectionName(item) {
    var name = $(item).attr('id') ? $(item).attr('id') : $(item).attr('class');

    return name.split(' ').slice(0, 2).join(' ');
}

/* -------------------------------------------------------------------------------------------------
 Helpers
 ------------------------------------------------------------------------------------------------- */

// пауза
function sleep(duration, callback)
{
	return setTimeout(callback, duration);
}

// parents
jQuery.expr[':'].parents = function(a,i,m){
    return jQuery(a).parents(m[3]).length < 1;
};

// сериализация в объект
$.fn.serializeObject = function() {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
        if (o[this.name]) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

// плавно скроллируем к нужному элементу
function scrollToElement(selector, callback, delta) {

    var destination = $(selector).offset();

    if (destination) {

        var top = (destination.top - 30 > 0) ? (destination.top - 30) : 0;

        delta = parseInt(delta, 10) || 0;

        top += delta;

        callback = callback || function() {};

        $('body, html').animate({'scrollTop': top}, {'duration': 1500, 'complete': function() {callback();}});
    }
}

/**
 * Аналог функции empty в php
 *
 * @param mixed_var
 * @returns {boolean}
 */
function empty(mixed_var) {

    let key, i, len;
    const emptyValues = [undefined, null, false, 0, '', '0'];

    for (i = 0, len = emptyValues.length; i < len; i++) {

        if (mixed_var === emptyValues[i]) {

            return true;
        }
    }

    if (typeof mixed_var === 'object') {

        for (key in mixed_var) {

            return false;
        }

        return true;
    }

    return false;
}

/**
 * Convert css units vh to px
 *
 * @param value
 * @returns {number}
 */
function vhToPx(value) {
    var documentElement = document.documentElement,
        body = document.getElementsByTagName('body')[0],
        //x = window.innerWidth || documentElement.clientWidth || body.clientWidth,
        y = window.innerHeight || documentElement.clientHeight || body.clientHeight;

    return (y * value) / 100;
}

/**
 * Convert css units vw to px
 *
 * @param value
 * @returns {number}
 */
function vwToPx(value) {
    var documentElement = document.documentElement,
        body = document.getElementsByTagName('body')[0],
        x = window.innerWidth || documentElement.clientWidth || body.clientWidth;

    return (x * value) / 100;
}

/* -------------------------------------------------------------------------------------------------
 @Debug
 ------------------------------------------------------------------------------------------------- */
/*let debug = function (options) {

    $('body').prepend('<div class="jsDebug"></div>');

    let defaults = {
            top: $('body').data('top') << 0 || 0,
            left: $('body').data('left') << 0 || 0,
            zIndex: 100000,
            opacity: 50,
            picture: null,
            maxZIndex: 100000
        },
        $debug = $('.jsDebug'),
        opacity = defaults.opacity / 100;

    options = $.extend(defaults, options);

    $debug.css({
        position: 'absolute',
        top: parseInt(options.top),
        left: parseInt(options.left),
        width: '100%',
        height: '5500%',
        zIndex: options.zIndex,
        textAlign: 'center',
        opacity: opacity,
        display: 'none',
        overflow: 'hidden',
    });

    $(document).ready(function() {
        $debug.append('<img src="' + getImageName() + '" alt="" class="js-debug-image">');
    });

    $(document).on('keydown', function (ev) {
//console.log(ev.keyCode);
        switch (ev.keyCode) {
            case 48:
            case 106:
                toggleDebug();
                break; //
            case 107:
                increaseOpacity();
                break; //
            case 109:
                decreaseOpacity();
                break; //
            case 187:
                upper();
                break; //
            case 189:
                lower();
                break; //
            case 111:
                adjustToScroll();
                break;
        }
    });

    $(window).on('resize', function (e) {

        let $image = $('.js-debug-image');

        $image.attr('src', getImageName());
    });

    let toggleDebug = function () {
        $debug.toggle();
    };

    let decreaseOpacity = function () {

        if (options.opacity > 10) {
            options.opacity = options.opacity - 10;
        }

        let opacity = options.opacity / 100;

        $debug.css({
            opacity: opacity
        })
    };

    let increaseOpacity = function () {

        if (options.opacity < 100) {
            options.opacity = options.opacity + 10;
        }

        let opacity = options.opacity / 100;

        $debug.css({
            opacity: opacity
        })
    };

    let toggleZIndex = function () {

        let zIndex = $debug.css('z-index') << 0;

        $debug.css('z-index', zIndex === 0 ? options.maxZIndex : 0);
    }

    let getImageName = function () {

        let defaultFileName = $('body').data('layout') || null,
            fileName = location.pathname.replace('.html', '').split('/').pop() || 'index',
            screenWidth = $(window).width();

        if (defaultFileName) {
            return defaultFileName;
        }

        if ([768, 375].indexOf(screenWidth) != -1) {

            fileName += '-' + screenWidth;
        }

        let result = './jpg/' + fileName + '.jpg'

        return result;
    }

    let lower = function () {

        let top = options.top - 1;

        options.top = top;

        $debug.css({top: top});
    };

    let upper = function () {

        let top = options.top + 1;

        options.top = top;
        $debug.css({top: top});
    };

    let adjustToScroll = function () {

        let top = $(window).scrollTop() << 0;
console.log(top);
        options.top = top;
        $debug.css({top: top});
    }
}; // */
